import { DOCUMENTS_PATHS } from '@store/skeletor/paths';
import { apiSkeletor } from '@store/skeletor/skeletorApi';
import { extractDataFromResponse } from '@utils/api/extractDataFromResponse';

import { type GetDocumentSiiStatusRequest } from './api.types';
import { type DocumentSiiStatus } from './types';

const documentSiiStatusesApi = apiSkeletor.injectEndpoints({
  endpoints: build => ({
    getDocumentSiiStatuses: build.query<
      DocumentSiiStatus[],
      GetDocumentSiiStatusRequest
    >({
      query: params => ({
        url: DOCUMENTS_PATHS.DTE_STATUS.BASE,
        params,
        method: 'GET',
      }),
      transformResponse: extractDataFromResponse,
    }),
  }),
});

export const { useGetDocumentSiiStatusesQuery } = documentSiiStatusesApi;
